import { SectionType } from '@space-shell/common/services/sections'

export const DefaultDynamicSectionsTitles = {
  [SectionType.PROGRESS]: 'my_progress',
  [SectionType.PURCHASED]: 'my_purchases',
  [SectionType.SALE]: 'sales'
}

export const AMOUNT_OF_CARDS = 4

export const ShowSeeALL = [SectionType.PURCHASED, SectionType.SALE]

export const DynamicSections = [SectionType.PROGRESS, SectionType.SALE, SectionType.PURCHASED]

export const ProductCardSections = [SectionType.PRODUCT, SectionType.SALE, SectionType.PURCHASED]
